"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DemoTabItem;
var _react = _interopRequireDefault(require("react"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
/**
 * 应该用在 Tabs 内部，如果单独使用，会直接渲染其 children
 */
function DemoTabItem(_ref) {
  var children = _ref.children,
    style = _ref.style;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('tab');
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-panel"),
    style: style
  }, children));
}